import React, { Component } from 'react';
import H3Subtitle from '../H3Subtitle/H3Subtitle.js';
import CategoryNameTile from '../CategoryNameTile/CategoryNameTile.js';
import Spinner from '../Spinner/Spinner.js'


/* Category Name Tiles Parent Component */
class CategoryNameTilesBlock extends Component {

    constructor(props) {
        super(props);
        this.state = {
            tilesData: {},
            isLoading: true,
            blockTitle: ''
        };
        this.getCategories = this.getCategoriesCall.bind(this);
    }

    componentDidMount() {
        this.getCategories();
    }

    /**
     * @method getCategoriesCall - gets data - whether from an API or object via this.props.data and processes it for the names tiles.
     */
    async getCategoriesCall() {
        let allCategories = { data: [] };
        let returnedData = {};
        try {
            if (typeof this.props.data === 'function') { // check the props type for 'function' to make api call
                allCategories = await this.props.data(1, 100);
                returnedData = allCategories.data.categories ? allCategories.data.categories : [];
            } else { // otherwise take the data directly - as is.
                allCategories.data = this.props.data ? this.props.data : {};
                returnedData = allCategories;
            }
            this.setState({ tilesData: returnedData });
            this.setState({ blockTitle: this.props.blockTitle });
            this.setState({ isLoading: false });
        } catch (error) {
            console.error(error);
        }
    }

    render() {
        return (
            <div id="courseCategoriesComponent">
                <React.Fragment>
                    <Spinner isLoading={this.state.isLoading}></Spinner>
                    <div className="container course-categories__block">
                        <H3Subtitle
                            titleClass={this.props.blockTitleClass}
                            titleText={this.state.blockTitle}
                        />
                        <div className="row course-categories__row">
                            <div className="row course-categories__inner mw-100">
                                <div className="course-categories__scroll__layer row">
                                    <div className="course-categories__scroll__layer__inner row">
                                        {(typeof (this.state.tilesData.data) !== 'undefined' && this.state.tilesData.data.length > 0) ? this.state.tilesData.data.map((category, index) =>
                                            <React.Fragment key={index}>
                                                {(category.course_count > 0) ?
                                                    <CategoryNameTile
                                                        name={category.category_name}
                                                        id={category.category_id}
                                                    >
                                                    </CategoryNameTile>
                                                    : ''}
                                            </React.Fragment>
                                        ) : ''}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            </div>
        );
    }
}

export default CategoryNameTilesBlock;